import { useQuery, useQueryClient } from "react-query";
import axios from "axios";

const fetchTradeHistory = () => {
  return axios.get(
    `https://server.anshfintech.com/api/user/data/trade-history`
  );
};

const fetchUsdtTradeHistory = () => {
  return axios.get(
    `https://server.anshfintech.com/api/user/data/usdt/usdt-trade-history`
  );
};

const fetchMarqueeData = () => {
  return axios.get(`https://server.anshfintech.com/api/user/marquee/text`);
};

export const UseTradeHistoryData = (hero) => {
  const queryClient = useQueryClient();
  return useQuery(["tradeHistory", hero], fetchTradeHistory, {
    initialData: () => {
      const data = queryClient
        .getQueryData("trade-heroes")
        ?.data?.find((data) => data.id === parseInt(hero));
      if (data) {
        return { data: data };
      } else {
        return undefined;
      }
    },
  });
};

export const UseUsdtTradeHistoryData = (hero) => {
  const queryClient = useQueryClient();
  return useQuery(["usdtTradeHistory", hero], fetchUsdtTradeHistory, {
    initialData: () => {
      const data = queryClient
        .getQueryData("trade-heroes")
        ?.data?.find((data) => data.id === parseInt(hero));
      if (data) {
        return { data: data };
      } else {
        return undefined;
      }
    },
  });
};

export const UseMarqueeText = (hero) => {
  const queryClient = useQueryClient();
  return useQuery(["marqueeText", hero], fetchMarqueeData, {
    initialData: () => {
      const data = queryClient
        .getQueryData("trade-heroes")
        ?.data?.find((data) => data.id === parseInt(hero));
      if (data) {
        return { data: data };
      } else {
        return undefined;
      }
    },
  });
};

export const updateTradeStatus = async (value, index, email) => {
  try {
    const response = await axios.post("https://server.anshfintech.com/api/common/live/update-trade", {
      row: index + 2, // Assuming the row index starts from 1
      value: value === "TRUE" ? "FALSE" : "TRUE",
      email: email,
      // email: "hrithiksingh157@gmail.com",
    });
    if (response.status === 200) {
      console.log("Update successful");
      return response;
    }
  } catch (error) {
    console.error("Error updating trade:", error);
  }
};
